// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__3-XUe"};